export default {
  heading: 'Open Sans, serif',
  subheading: 'Lobster, sans-serif',
  body: 'Open Sans, serif',
  monospace: 'Menlo, monospace',
  display: 'Fredericka the Great',
  googleFonts: [
    // 'Righteous',
    // 'Rubik:100,200,300,400,500,600,700,800,900',
    // 'Monofett',
    'Fredericka the Great',
    'Open Sans:100,200,300,400,500,600,700,800,900'
  ]
  // customFamilies: ['Burford-Rustic'],
  // customUrls: [
  //   'https://www.gonation.biz/fonts/burford-rustic/burford-rustic.css',
  // ],
}
